import { SUBCLUSTERS } from '../subclusters.js';

const INFORMATION_TECHNOLOGY_CLUSTER = {
    subclusters: [
        {
            key: SUBCLUSTERS.TASKS,
        },
        {
            key: SUBCLUSTERS.MANAGING_PROJECTS_PORTFOLIO,
        },
        {
            key: SUBCLUSTERS.RESOURCE_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.REPORTING_TO_EXECUTIVES,
        },
        {
            key: SUBCLUSTERS.KNOWLEDGE_BASE,
        },
        {
            key: SUBCLUSTERS.TICKETS_AND_REQUESTS,
        },
        {
            key: SUBCLUSTERS.IT_SERVICE_DESK,
        },
        {
            key: SUBCLUSTERS.PROJECT_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.CRM,
        },
        {
            key: SUBCLUSTERS.SOFTWARE_DEVELOPMENT,
        },
    ],
    mini_site: {
        logo: {
            alt: 'monday.com Service',
            url: '/w/service',
            src: 'https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/minisites/header%20logos/service/monday_service_with_logo_406-112.png',
            mobileSrc: 'https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/minisites/header%20logos/service/monday_service_no_logo_346-112.png',
        },
        links: [
            {
                url: '/w/service',
                text: 'minisite.header.overview',
            },
            {
                url: '/service/pricing',
                text: 'minisite.header.pricing',
                isPricingPage: 'true',
            },
        ],
        unifiedDesktopLogo: {
            url: '/service',
            src: 'https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/minisites/header%20logos/service/monday_service_with_logo_406-112_2x.png',
            alt: 'monday.com Service',
        },
    },
};

export { INFORMATION_TECHNOLOGY_CLUSTER };
